import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/login',
      component: (resolve) => { require(['view/pages/login'], resolve) }
    },{
      path: '/getPassword',
      component: (resolve) => { require(['view/pages/getPassword'], resolve) }
    },
    {
      path: '/index',
      component: (resolve) => { require(['view/pages/index'], resolve) }
    },
    {
      path: '/new',
      component: (resolve) => { require(['view/pages/new'], resolve) }
    },
    {
      path: '/userinfo',
      component: (resolve) => { require(['view/user/userinfo'], resolve) },
    },
    {
      path: '/userinfo/myCollections',
      component: (resolve) => { require(['view/user/myCollections'], resolve) }
    },
    {
      path: '/myInfo',
      component: (resolve) => { require(['view/pages/myInfo'], resolve) }
    },
    {
      path: '/favorite',
      component: (resolve) => { require(['view/user/favorite/favorite'], resolve) }
    },
    {
      path: '/comic',
      component: (resolve) => { require(['view/user/comic/comic'], resolve) }
    },
    {
      path: '/chapter',
      component: (resolve) => { require(['view/user/comic/chapter'], resolve) }
    },
    {
      path: '/comment',
      component: (resolve) => { require(['view/base/Comment/Panel/CommentPanel'], resolve) }
    },
    {
      path: '/reply',
      component: (resolve) => { require(['view/base/Comment/Panel/ReplyPanel'], resolve) }
    },
    {
      path: '/pubchapter',
      component: (resolve) => { require(['view/user/comic/pubchapter'], resolve) }
    },
    {
      path: '/pubcomics',
      component: (resolve) => { require(['view/user/comic/pubcomic'], resolve) }
    },
    {
      path: '/category',
      component: (resolve) => { require(['view/pages/category'], resolve) }
    },
    {
      path: '/rank',
      component: (resolve) => { require(['view/pages/rank'], resolve) }
    },
    {
      path: '/detail',
      component: (resolve) => { require(['view/pages/detail'], resolve) }
    },
    {
      path: '/read',
      component: (resolve) => { require(['view/pages/Read'], resolve) }
    },
    {
      path: '/fee',
      component: (resolve) => { require(['view/pages/fee'],resolve)}
    },
    {
      path: '/charge',
      component: (resolve) => { require(['view/pages/charge'],resolve)}
    },
    {
      path: '/about',
      component: (resolve) => { require(['view/pages/about'],resolve)}
    },
    {
      path: '/contact',
      component: (resolve) => { require(['view/pages/contact'],resolve)}
    },
    {
      path: '/falv',
      component: (resolve) => { require(['view/pages/falv'],resolve)}
    },
    {
      path: '/zishen',
      component: (resolve) => { require(['view/pages/zishen'],resolve)}
    },
    {
      path: '/yinsi',
      component: (resolve) => { require(['view/pages/yinsi'],resolve)}
    },
    {
      path: '/wcn',
      component: (resolve) => { require(['view/pages/weicn'],resolve)}
    },
    {
      path: '/yhxy',
      component: (resolve) => { require(['view/pages/yhxy'],resolve)}
    },
    {
      path: '/wxpay',
      component: (resolve) => { require(['view/pages/wxpay'],resolve)}
    },
    {
      path: '/test',
      component: (resolve) => { require(['view/pages/test'],resolve)}
    }
  ],
  scrollBehavior(to, from, savePosition) {
    // return 期望滚动到哪个的位置
    return {
      y: 0,
    };
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js